export default __webpack_public_path__ + "media/images/features/ambassador/profiles/mishiko_san-e0e2a058bd35bcb57c81aa585343636b.jpg";